/**
 * Toast Notification Utilities
 */
import { toast } from 'react-toastify';

export interface ToastOptions {
  autoClose?: number;
  hideProgressBar?: boolean;
  closeOnClick?: boolean;
  pauseOnHover?: boolean;
  draggable?: boolean;
}

/**
 * Show success toast
 */
export const showSuccess = (message: string, options?: ToastOptions) => {
  toast.dismiss();
  toast.success(message, {
    position: 'top-right',
    autoClose: options?.autoClose ?? 4000,
    hideProgressBar: options?.hideProgressBar ?? false,
    closeOnClick: options?.closeOnClick ?? true,
    pauseOnHover: options?.pauseOnHover ?? true,
    draggable: options?.draggable ?? true,
    ...options,
  });
};

/**
 * Show error toast
 */
export const showError = (message: string, options?: ToastOptions) => {
  toast.dismiss();
  toast.error(message || 'Something went wrong', {
    position: 'top-right',
    autoClose: options?.autoClose ?? 4000,
    hideProgressBar: options?.hideProgressBar ?? false,
    closeOnClick: options?.closeOnClick ?? true,
    pauseOnHover: options?.pauseOnHover ?? true,
    draggable: options?.draggable ?? true,
    ...options,
  });
};

/**
 * Show warning toast
 */
export const showWarning = (message: string, options?: ToastOptions) => {
  toast.dismiss();
  toast.warn(message || 'Warning', {
    position: 'top-right',
    autoClose: options?.autoClose ?? 4000,
    hideProgressBar: options?.hideProgressBar ?? false,
    closeOnClick: options?.closeOnClick ?? true,
    pauseOnHover: options?.pauseOnHover ?? true,
    draggable: options?.draggable ?? true,
    ...options,
  });
};

/**
 * Show info toast
 */
export const showInfo = (message: string, options?: ToastOptions) => {
  toast.dismiss();
  toast.info(message, {
    position: 'top-right',
    autoClose: options?.autoClose ?? 4000,
    hideProgressBar: options?.hideProgressBar ?? false,
    closeOnClick: options?.closeOnClick ?? true,
    pauseOnHover: options?.pauseOnHover ?? true,
    draggable: options?.draggable ?? true,
    ...options,
  });
};

/**
 * Generic toast function
 */
export const showToast = (
  message: string,
  type: 'success' | 'error' | 'warning' | 'info' = 'info',
  options?: ToastOptions
) => {
  switch (type) {
    case 'success':
      showSuccess(message, options);
      break;
    case 'error':
      showError(message, options);
      break;
    case 'warning':
      showWarning(message, options);
      break;
    case 'info':
    default:
      showInfo(message, options);
      break;
  }
};

